import { useTranslation } from 'next-i18next';
import { BriefcaseIcon } from '@heroicons/react/24/outline';

import { Heading, Spinner } from '@restworld/ui-ds-base';

import { useJobPositionId } from '../../../hooks';
import { useSimilarJobPositionsPaginated } from '../../../hooks/use-similar-job-positions-paginated';
import { SimilarJobsList } from '../../offline-job-landing/similar-jobs-list';

// "Posizioni simili" section at the bottom of the JP detail page.
//
// Reuses the same paginated hook + compact list component that the
// offline-JP modal uses, so the visual + data layer stay in sync between
// the two surfaces. Replaces the legacy carousel-driven
// `JobSimilarPositions` from `@restworld/ui-ds` (was loading 3 items
// statically from `similarJobPositionsAtom` and rendering as a
// horizontally-scrolling carousel).
//
// Renders nothing while the first page is loading, and nothing if the
// JP has no similar positions to surface — same hide-when-empty behavior
// as the legacy block.
export const SimilarJobs = () => {
  const { t } = useTranslation('job-position-page');
  const jobPositionId = useJobPositionId();
  const { items, hasMore, isLoading, isInitialLoading, loadMore } = useSimilarJobPositionsPaginated(jobPositionId);

  if (isInitialLoading) {
    return (
      <>
        <hr className="text-gray-300" />
        <div id="similar-jobs-el" className="flex flex-col gap-4 w-full">
          <Heading size={4} weight="semibold" color="neutral" className="flex items-center gap-2">
            <BriefcaseIcon className="h-6 w-6" />
            {t('similar_positions')}
          </Heading>
          <div className="flex justify-center py-8">
            <Spinner color="primary" />
          </div>
        </div>
      </>
    );
  }

  if (items.length === 0) return null;

  return (
    <>
      <hr className="text-gray-300" />
      <div id="similar-jobs-el" className="flex flex-col gap-4 w-full">
        <Heading size={4} weight="semibold" color="neutral" className="flex items-center gap-2">
          <BriefcaseIcon className="h-6 w-6" />
          {t('similar_positions')}
        </Heading>
        <SimilarJobsList items={items} hasMore={hasMore} isLoading={isLoading} onLoadMore={loadMore} />
      </div>
    </>
  );
};
